import React from 'react';

interface DateSeparatorProps {
        displayDate: string;
}

const DateSeparator: React.FC<DateSeparatorProps> = ({ displayDate }) => {
        return (
            <div className="flex items-center my-6">
                    <div className="flex-1 h-px bg-line"></div>
                    <div className="px-4 py-1 text-xxs text-ink-muted bg-surface rounded-full font-medium">
                            {displayDate}
                    </div>
                    <div className="flex-1 h-px bg-fill-subtle"></div>
            </div>
        );
};

export default DateSeparator;